import React from 'react'
import doctor from "../assets/mfrmdoom 1.png";

const OurStoryImg = () => {
  return (

          <div className="">
          <img src={doctor} alt="nerve" className='md:w-[80%] lg:w-[580px] lg:h-[600px] lg:p-3 object-cover'/>
        </div>
    
  )
}

export default OurStoryImg